package one.healthium.update_food_preferences.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class FoodPreferenceOptionDto(
    @SerialName("key") val id: String,
    @SerialName("status") val status: String,
)
